module.exports = __webpack_public_path__ + "img/epWithdraw.19c61052.png";